import { render, staticRenderFns } from "./SubscriptionAlert.vue?vue&type=template&id=dd4b57e2&scoped=true"
import script from "./SubscriptionAlert.vue?vue&type=script&lang=ts"
export * from "./SubscriptionAlert.vue?vue&type=script&lang=ts"
import style0 from "./SubscriptionAlert.vue?vue&type=style&index=0&id=dd4b57e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4b57e2",
  null
  
)

export default component.exports